import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    nav: { home: 'Home', projects: 'Projects', graphicDesign: 'Graphic Design', certifications: 'Certifications', about: 'About', contact: 'Contact', cv: 'CV' },
    home: {
      greeting: "Hello, I'm a",
      title: 'Computer Science Student',
      subtitle: 'Passionate about building AI-powered web-based and software systems.',
      viewProjects: 'View Projects',
      downloadCV: 'Download CV',
      getInTouch: 'Get In Touch',
      skillsTech: 'Skills & Technologies',
      viewAllSkills: 'View All Skills',
      featuredProjects: 'Featured Projects',
      viewProject: 'View Project',
      code: 'Code',
      liveDemo: 'Live Demo',
      backToTop: 'Back to Top',
    },
    about: {
      title: 'About Me',
      skillsTech: 'Skills & Technologies',
      languages: 'Languages',
      frontend: 'Frontend',
      backend: 'Backend',
      tools: 'Tools & Technologies',
      experience: 'Experience',
      education: 'Education',
      present: 'Present',
    },
    projects: {
      title: 'My Projects',
      subtitle: 'A collection of my work in web development and software engineering',
      viewProject: 'View Project',
      code: 'Code',
      liveDemo: 'Live Demo',
      all: 'All',
      web: 'Web',
      software: 'Software',
    },
    contact: {
      title: 'Get In Touch',
      subtitle: "Have a project in mind or want to collaborate? I'd love to hear from you!",
      contactInfo: 'Contact Information',
      sendMessage: 'Send Message',
      name: 'Name',
      email: 'Email',
      subject: 'Subject',
      message: 'Message',
      send: 'Send Message',
      sending: 'Sending...',
      successMessage: 'Message sent successfully! I will get back to you soon.',
      errorMessage: 'Failed to send message. Please try again.',
      location: 'Location',
    },
    footer: {
      quickLinks: 'Quick Links',
      resources: 'Resources',
      connect: 'Connect',
      rights: 'All rights reserved.',
    },
    onboarding: {
      welcomeTitle: 'Welcome',
      welcomeText: 'Explore the portfolio, projects, skills, and contact options from here.',
      projectsTitle: 'Projects',
      projectsText: 'Browse projects, filter by category, and open live demos or source code.',
      designTitle: 'Graphic Design',
      designText: 'View visual design work and creative assets.',
      aboutTitle: 'About',
      aboutText: 'Learn about skills, experience, education, and background.',
      contactTitle: 'Contact',
      contactText: 'Use the contact form to send a message directly.',
      languageTitle: 'Language',
      languageText: 'Switch the interface language at any time.',
      assistantTitle: 'Assistant',
      assistantText: 'Open the assistant for quick answers about Bernard.',
      counterTitle: 'Visitor Counter',
      counterText: 'The counter records one visit per page load after the footer is reached.',
      skip: 'Skip',
      next: 'Next',
      finish: 'Finish'
    },
  },
  nya: {
    nav: { home: 'Kunyumba', projects: 'Ntchito', graphicDesign: 'Kupanga Zithunzi', certifications: 'Zitsimikizo', about: 'Za Ine', contact: 'Lumikizana', cv: 'CV' },
    home: {
      greeting: 'Moni, Ndine',
      title: 'Wophunzira wa Sayansi ya Makompyuta',
      subtitle: 'Ndili ndi chidwi chomanga makina a AI komanso mapulogalamu a pa intaneti.',
      viewProjects: 'Onani Ntchito',
      downloadCV: 'Tsitsani CV',
      getInTouch: 'Lumikizana Nane',
      skillsTech: 'Maluso ndi Ukadaulo',
      viewAllSkills: 'Onani Maluso Onse',
      featuredProjects: 'Ntchito Zodziwika',
      viewProject: 'Onani Ntchito',
      code: 'Khodi',
      liveDemo: 'Chiwonetsero Chanthawi Yeniyeni',
      backToTop: 'Bwererani Pamwamba',
    },
    about: {
      title: 'Za Ine',
      skillsTech: 'Maluso ndi Ukadaulo',
      languages: 'Zinenero',
      frontend: 'Kutsogolo',
      backend: 'Kumbuyo',
      tools: 'Zida ndi Ukadaulo',
      experience: 'Zochitika',
      education: 'Maphunziro',
      present: 'Pakali pano',
      bioFallback: 'Ndine wophunzira wa sayansi ya makompyuta yemwe ndili ndi chidwi chomanga makina a AI komanso mapulogalamu a pa intaneti. Ndili ndi maziko amphamvu mu chitukuko cha intaneti, uinjiniya wa mapulogalamu, kapangidwe ka ma database, kasamalidwe ka ma database ndi kusanthula deta. Ulendo wanga mu ukadaulo unayamba ndi chidwi chofuna kudziwa momwe zinthu zimagwirira ntchito, ndipo wasinthidwa kukhala chidwi chopanga mapulogalamu othandiza.',
      fallbackTitle: 'Wophunzira wa Sayansi ya Makompyuta',
      fallbackLocation: 'Lusaka',
      location: 'Malo',
    },
    projects: {
      title: 'Ntchito Zanga',
      subtitle: 'Mndandanda wa ntchito zanga mu chitukuko cha intaneti ndi uinjiniya wa mapulogalamu',
      viewProject: 'Onani Ntchito',
      code: 'Khodi',
      liveDemo: 'Chiwonetsero Chanthawi Yeniyeni',
      all: 'Zonse',
      web: 'Intaneti',
      software: 'Mapulogalamu',
    },
    contact: {
      title: 'Lumikizana Nane',
      subtitle: "Muli ndi ntchito m'malingaliro kapena mukufuna kugwira ntchito limodzi? Ndikufuna kumva kuchokera kwa inu!",
      contactInfo: 'Zambiri Zolumikizana',
      sendMessage: 'Tumizani Uthenga',
      name: 'Dzina',
      email: 'Imelo',
      subject: 'Mutu',
      message: 'Uthenga',
      send: 'Tumizani Uthenga',
      sending: 'Kutumiza...',
      successMessage: 'Uthenga watumizidwa bwino! Ndibwerera kwa inu posachedwa.',
      errorMessage: 'Kulephera kutumiza uthenga. Chonde yesaninso.',
      location: 'Malo',
    },
    footer: {
      quickLinks: 'Maulalo Achangu',
      resources: 'Zothandizira',
      connect: 'Lumikizana',
      rights: 'Ufulu wonse ndi wosungidwa.',
    },
    onboarding: {
      welcomeTitle: 'Takulandirani',
      welcomeText: 'Onani zinthunzi, ntchito, maluso ndi njira zolumikizirana pano.',
      projectsTitle: 'Ntchito',
      projectsText: 'Sakani ntchito, sankhani mtundu ndi kutsegula zitsanzo kapena khodi.',
      designTitle: 'Kupanga Zithunzi',
      designText: 'Onani ntchito yopanga zithunzi ndi zinthu zolengedwa.',
      aboutTitle: 'Za Ine',
      aboutText: 'Dziwani za maluso, zochitika, maphunziro ndi mbiri yanga.',
      contactTitle: 'Lumikizana',
      contactText: 'Gwiritsani ntchito fomu yolumikizirana kutumiza uthenga mwachindunji.',
      languageTitle: 'Chiyankhulo',
      languageText: 'Sinthani chiyankhulo cha mawonekedwe nthawi iliyonse.',
      assistantTitle: 'Wothandiza',
      assistantText: 'Tsegulani wothandiza kuti mupeze mayankho ofulumira za Bernard.',
      counterTitle: 'Kuwerengera Alendo',
      counterText: 'Kuwerengera kumalemba ulendo umodzi pa tsamba lililonse pambuyo poti footer yafikika.',
      skip: 'Dumphani',
      next: 'Chotsatira',
      finish: 'Malizitsani'
    },
  },
  ny: {
    nav: { home: 'Kunyumba', projects: 'Ntchito', graphicDesign: 'Kujambula', certifications: 'Satifiketi', about: 'Za Ine', contact: 'Lumikizana', cv: 'CV' },
    home: {
      greeting: 'Moni, Ndine',
      title: 'Wophunzira wa Sayansi ya Makompyuta',
      subtitle: 'Ndimakonda kupanga makina a AI komanso mapulogalamu a pa intaneti.',
      viewProjects: 'Onani Ntchito',
      downloadCV: 'Tsitsani CV',
      getInTouch: 'Lumikizanani Nane',
      skillsTech: 'Luso ndi Zida',
      viewAllSkills: 'Onani Maluso Onse',
      featuredProjects: 'Ntchito Zofunika',
      viewProject: 'Onani Ntchito',
      code: 'Khodi',
      liveDemo: 'Onani Mwachindunji',
      backToTop: 'Bwererani Pamwamba',
    },
    about: {
      title: 'Za Ine',
      skillsTech: 'Luso ndi Zida',
      languages: 'Zilankhulo',
      frontend: 'Kutsogolo',
      backend: 'Kumbuyo',
      tools: 'Zida',
      experience: 'Zomwe Ndagwira',
      education: 'Maphunziro',
      present: 'Pakadali pano',
      bioFallback: 'Ndine wophunzira wa sayansi ya makompyuta yemwe ndimakonda kupanga makina a AI ndi mapulogalamu a pa intaneti. Ndili ndi chidziwitso pakupanga mawebusaiti, uinjiniya wa mapulogalamu, kupanga ndi kusamalira ma database komanso kusanthula deta. Ndinayamba chidwi changa chifukwa chofuna kudziwa momwe zinthu zimagwirira ntchito ndipo tsopano ndimakonda kupanga mapulogalamu othandiza anthu.',
      fallbackTitle: 'Wophunzira wa Sayansi ya Makompyuta',
      fallbackLocation: 'Lusaka',
      location: 'Malo',
    },
    projects: {
      title: 'Ntchito Zanga',
      subtitle: 'Mndandanda wa ntchito zomwe ndachita pakupanga mawebusaiti ndi mapulogalamu',
      viewProject: 'Onani Ntchito',
      code: 'Khodi',
      liveDemo: 'Onani Mwachindunji',
      all: 'Zonse',
      web: 'Pa Intaneti',
      software: 'Mapulogalamu',
    },
    contact: {
      title: 'Lumikizanani Nane',
      subtitle: "Ngati muli ndi ntchito m'maganizo kapena mukufuna kugwira nane ntchito limodzi, ndingakondwe kumva kuchokera kwa inu!",
      contactInfo: 'Zambiri Zolumikizirana',
      sendMessage: 'Tumizani Uthenga',
      name: 'Dzina',
      email: 'Imelo',
      subject: 'Mutu',
      message: 'Uthenga',
      send: 'Tumizani Uthenga',
      sending: 'Nditumiza...',
      successMessage: 'Uthenga wanu watumizidwa bwino! Ndidzakuyankhani posachedwa.',
      errorMessage: 'Zalephera kutumiza uthenga. Chonde yesaninso.',
      location: 'Malo',
    },
    footer: {
      quickLinks: 'Maulalo Ofulumira',
      resources: 'Zothandizira',
      connect: 'Lumikizanani',
      rights: 'Ufulu wonse ndi wotetezedwa.',
    },
    onboarding: {
      welcomeTitle: 'Mwalandiridwa',
      welcomeText: 'Onani ma projekiti, maluso, ndiponso njira zolumikizirana pano.',
      projectsTitle: 'Ma Projekiti',
      projectsText: 'Yang\'anani ma projekiti, sankhani gulu lanu, ndiponso onani ma demo kapena khodi.',
      designTitle: 'Kujambula',
      designText: 'Onani ntchito zanga zojambula ndi zaluso.',
      aboutTitle: 'Za Ine',
      aboutText: 'Dziwani zambiri za maluso anga, zomwe ndachita, maphunziro ndi mbiri yanga.',
      contactTitle: 'Lumikizanani',
      contactText: 'Gwiritsani ntchito fomu iyi kutumiza uthenga mwachindunji kwa ine.',
      languageTitle: 'Chilankhulo',
      languageText: 'Sinthani chilankhulo cha tsamba lino nthawi yomwe mukufuna.',
      assistantTitle: 'Mothandizira',
      assistantText: 'Tsegulani mothandizira kuti mupeze mayankho mwachangu za Bernard.',
      counterTitle: 'Owerengera Alendo',
      counterText: 'Chiwerengerochi chimalemba munthu mmodzi pa tsamba lililonse akafika kumapeto kwa tsamba.',
      skip: 'Dumphani',
      next: 'Pita Patsogolo',
      finish: 'Malizani'
    },
  },
  fr: {
    nav: { home: 'Accueil', projects: 'Projets', graphicDesign: 'Design Graphique', certifications: 'Certifications', about: 'À propos', contact: 'Contact', cv: 'CV' },
    home: {
      greeting: "Bonjour, je suis un",
      title: "Étudiant en Informatique",
      subtitle: "Passionné par la création de systèmes logiciels et web basés sur l'IA.",
      viewProjects: 'Voir les Projets',
      downloadCV: 'Télécharger CV',
      getInTouch: 'Me Contacter',
      skillsTech: 'Compétences et Technologies',
      viewAllSkills: 'Voir Toutes les Compétences',
      featuredProjects: 'Projets en Vedette',
      viewProject: 'Voir le Projet',
      code: 'Code',
      liveDemo: 'Démo en Direct',
      backToTop: 'Retour en Haut',
    },
    about: {
      title: 'À Propos de Moi',
      skillsTech: 'Compétences et Technologies',
      languages: 'Langages',
      frontend: 'Frontend',
      backend: 'Backend',
      tools: 'Outils et Technologies',
      experience: 'Expérience',
      education: 'Éducation',
      present: 'Présent',
    },
    projects: {
      title: 'Mes Projets',
      subtitle: 'Une collection de mes travaux en développement web et en génie logiciel',
      viewProject: 'Voir le Projet',
      code: 'Code',
      liveDemo: 'Démo en Direct',
      all: 'Tous',
      web: 'Web',
      software: 'Logiciel',
    },
    contact: {
      title: 'Me Contacter',
      subtitle: "Vous avez un projet en tête ou souhaitez collaborer ? J'aimerais avoir de vos nouvelles !",
      contactInfo: "Informations de Contact",
      sendMessage: 'Envoyer un Message',
      name: 'Nom',
      email: 'Email',
      subject: 'Sujet',
      message: 'Message',
      send: 'Envoyer un Message',
      sending: 'Envoi en cours...',
      successMessage: 'Message envoyé avec succès ! Je vous recontacterai bientôt.',
      errorMessage: "Échec de l'envoi du message. Veuillez réessayer.",
      location: 'Emplacement',
    },
    footer: {
      quickLinks: 'Liens Rapides',
      resources: 'Ressources',
      connect: 'Se Connecter',
      rights: 'Tous droits réservés.',
    },
  },
  pt: {
    nav: { home: 'Início', projects: 'Projetos', graphicDesign: 'Design Gráfico', about: 'Sobre', contact: 'Contato', cv: 'CV' },
    home: {
      greeting: 'Olá, eu sou um',
      title: 'Estudante de Ciência da Computação',
      subtitle: 'Apaixonado por construir sistemas web e de software baseados em IA.',
      viewProjects: 'Ver Projetos',
      downloadCV: 'Baixar CV',
      getInTouch: 'Entrar em Contato',
      skillsTech: 'Habilidades e Tecnologias',
      viewAllSkills: 'Ver Todas as Habilidades',
      featuredProjects: 'Projetos em Destaque',
      viewProject: 'Ver Projeto',
      code: 'Código',
      liveDemo: 'Demonstração Ao Vivo',
      backToTop: 'Voltar ao Topo',
    },
    about: {
      title: 'Sobre Mim',
      skillsTech: 'Habilidades e Tecnologias',
      languages: 'Idiomas',
      frontend: 'Frontend',
      backend: 'Backend',
      tools: 'Ferramentas e Tecnologias',
      experience: 'Experiência',
      education: 'Educação',
      present: 'Presente',
    },
    projects: {
      title: 'Meus Projetos',
      subtitle: 'Uma coleção dos meus trabalhos em desenvolvimento web e engenharia de software',
      viewProject: 'Ver Projeto',
      code: 'Código',
      liveDemo: 'Demonstração Ao Vivo',
      all: 'Todos',
      web: 'Web',
      software: 'Software',
    },
    contact: {
      title: 'Entrar em Contato',
      subtitle: 'Tem um projeto em mente ou quer colaborar? Adoraria ouvir de você!',
      contactInfo: 'Informações de Contato',
      sendMessage: 'Enviar Mensagem',
      name: 'Nome',
      email: 'Email',
      subject: 'Assunto',
      message: 'Mensagem',
      send: 'Enviar Mensagem',
      sending: 'Enviando...',
      successMessage: 'Mensagem enviada com sucesso! Entrarei em contato em breve.',
      errorMessage: 'Falha ao enviar mensagem. Tente novamente.',
      location: 'Localização',
    },
    footer: {
      quickLinks: 'Links Rápidos',
      resources: 'Recursos',
      connect: 'Conectar',
      rights: 'Todos os direitos reservados.',
    },
  },
  bem: {
    nav: { home: "Ing'anda", projects: 'Imilimo', graphicDesign: 'Ukupanga Ifikope', about: 'Pali Ine', contact: 'Ukutuma', cv: 'CV' },
    home: {
      greeting: 'Mwapoleni, Nine',
      title: 'Umusambilila wa Computer Science',
      subtitle: 'Ninkwatapo ukutemwa ukukula amafya ya AI na mapulogalamu ya pa intaneti.',
      viewProjects: 'Moneni Imilimo',
      downloadCV: 'Pokelai CV',
      getInTouch: 'Mwipusha',
      skillsTech: 'Amaka na Ubuchwepheshe',
      viewAllSkills: 'Moneni Amaka Yonse',
      featuredProjects: 'Imilimo Iisuma',
      viewProject: 'Moneni Umulimo',
      code: 'Code',
      liveDemo: 'Ukulanga Pa Cine',
      backToTop: 'Bwelai Pamwamba',
    },
    about: {
      title: 'Pali Ine',
      skillsTech: 'Amaka na Ubuchwepheshe',
      languages: 'Indimi',
      frontend: 'Ukufuma kunse',
      backend: 'Kumbali',
      tools: 'Ifipe na Ubuchwepheshe',
      experience: 'Ifyo Nacita',
      education: 'Ifya Masambililo',
      present: 'Nomba',
    },
    projects: {
      title: 'Imilimo Yandi',
      subtitle: 'Ulubali lwa milimo yandi mu kupanga amapeji ya intaneti na mapulogalamu',
      viewProject: 'Moneni Umulimo',
      code: 'Code',
      liveDemo: 'Ukulanga Pa Cine',
      all: 'Fyonse',
      web: 'Intaneti',
      software: 'Mapulogalamu',
    },
    contact: {
      title: 'Mwipusha',
      subtitle: 'Muli ne cipangilwe mu mutima nelyo mulefwaya ukubomba pamo? Ndefwaya ukumfwa kuli imwe!',
      contactInfo: 'Ifishinka fya Kukumanya',
      sendMessage: 'Tumineni Ubufwi',
      name: 'Ishina',
      email: 'Imeli',
      subject: 'Umutwe',
      message: 'Ubufwi',
      send: 'Tumineni Ubufwi',
      sending: 'Kulekutuma...',
      successMessage: 'Ubufwi batumine bwino! Nkasuka kuli imwe bwangu bwangu.',
      errorMessage: 'Kulekana kutuma ubufwi. Napapata, esheni na kabili.',
      location: 'Incende',
    },
    footer: {
      quickLinks: 'Ifishinte Fya Bwangu',
      resources: 'Ifyakubomfya',
      connect: 'Kukumanya',
      rights: 'Amaka yonse yacingililwa.',
    },
  },
  toi: {
    nav: { home: 'Kuŋanda', projects: 'Milimo', graphicDesign: 'Kupanga Zitondezyo', about: 'Ajili Lyangu', contact: 'Kumukwabilila', cv: 'CV' },
    home: {
      greeting: 'Muli kabotu, Ndime',
      title: 'Mwiiyi wa Computer Science',
      subtitle: 'Ndilijisi luyando lwakuyaka masimino aa AI aazibelesegwa aamutwe oonse.',
      viewProjects: 'Bona Milimo',
      downloadCV: 'Kopola CV',
      getInTouch: 'Kumukwabilila',
      skillsTech: 'Mpuwo a Zipego',
      viewAllSkills: 'Bona Mpuwo Zyoonse',
      featuredProjects: 'Milimo Iisumpikizidwe',
      viewProject: 'Bona Mulimo',
      code: 'Code',
      liveDemo: 'Kutondezya Mu Busena',
      backToTop: 'Jokela Kujulu',
    },
    about: {
      title: 'Ajili Lyangu',
      skillsTech: 'Mpuwo a Zipego',
      languages: 'Myambo',
      frontend: 'Kunjilila',
      backend: 'Kusule',
      tools: 'Zipego a Zibelesyo',
      experience: 'Zyakacitika',
      education: 'Kwiiyi',
      present: 'Sunu',
    },
    projects: {
      title: 'Milimo Yangu',
      subtitle: 'Mubunganino wamilimo yangu mukuyaka mawebbusaiti aazibelesegwa',
      viewProject: 'Bona Mulimo',
      code: 'Code',
      liveDemo: 'Kutondezya Mu Busena',
      all: 'Zyoonse',
      web: 'Webbu',
      software: 'Mapulogalamu',
    },
    contact: {
      title: 'Kumukwabilila',
      subtitle: 'Mujisi mulimo mumiyeeyo naakuti muyanda kubelekela antoomwe? Ndayanda kumvwa kulindinywe!',
      contactInfo: 'Makkani Aakukwabilila',
      sendMessage: 'Tuma Mulao',
      name: 'Zina',
      email: 'Imelo',
      subject: 'Mutwe',
      message: 'Mulao',
      send: 'Tuma Mulao',
      sending: 'Kutuma...',
      successMessage: 'Mulao watumwa kabotu! Ndilamwiingula cakufwambaana.',
      errorMessage: 'Kukakilwa kutuma mulao. Amubweedezye alimwi.',
      location: 'Busena',
    },
    footer: {
      quickLinks: 'Ziyungizyo Zyakufwambaana',
      resources: 'Zyakubelesya',
      connect: 'Kukwabilila',
      rights: 'Makani oonse alisalidwe.',
    },
  },
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'en';
  });

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (let k of keys) {
      value = value?.[k];
    }
    if (value) {
      return value;
    }

    let fallback = translations.en;
    for (let k of keys) {
      fallback = fallback?.[k];
    }
    return fallback || key;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
